var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ranking-sixth"},[_c('teacherWork',{attrs:{"tableData":_vm.tableData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }